/* eslint-disable */
import { createReducer, on, Action } from "@ngrx/store";
import * as AuthActions from "./auth.actions";

export const AUTH_FEATURE_KEY = "auth";

export interface AuthState {
    authenticated: boolean;
    profile: any;
    error: any | undefined;
}

export const initialAuthState: AuthState = {
    authenticated: false,
    profile: null,
    error: null,
};

const authReducerInternal = createReducer(
    initialAuthState,
    on(AuthActions.login, (state, {}) => {
        return {
            ...state,
            profile: null,
            authenticated: false,
            error: null,
        };
    }),
    on(AuthActions.loginComplete, (state, { profile, authenticated }) => {
        return {
            ...state,
            profile,
            authenticated,
            error: null,
        };
    }),
    on(AuthActions.loginFailure, (state, { error }) => {
        return {
            ...state,
            error,
        };
    }),
    on(AuthActions.logout, (state, {}) => {
        return {
            ...state,
            profile: null,
            authenticated: false,
            error: null,
        };
    }),
);

export function authReducer(state: AuthState | undefined, action: Action) {
    return authReducerInternal(state, action);
}
